// extracted by mini-css-extract-plugin
export default {"text":"deactivateModal_text__J5pCh","container":"deactivateModal_container__yHoJ8"};